window.Format = function() {
    var el = this;
    el.current = {};
    el.items = {};
    var template = $('#formats-template').html();
    
    el.init = function() {
        var availFormats = {};
        var propertyId, formatId;
        var price = el.calculator.price[el.calculator.priceGroupId][el.project.current.product_id];
        
        for (propertyId in price) {
            for (formatId in price[propertyId]) {
                availFormats[formatId] = el.items[formatId];
            }
        }

        if (Object.keys(availFormats).length === 0) {
            alert('У компании не найдено зарегистрированных форматов');
        }
        
        var id = 0;
        
        if ( el.project.current.constructor.hasOwnProperty('workareas')) {
            id = el.project.current.constructor.workareas[1].format_id;
        }
        
        if (el.project.current.format_id !== '0' && id === 0) {
            id = el.project.current.format_id;
        }
        
        if (!availFormats.hasOwnProperty(id) || id === 0) {
            id = Object.keys(availFormats)[0];
        }
        
        el.current = el.items[id];
    };
    
    el.render = function() {
        var templateData = {
            default_format: el.current,
            currency: el.calculator.currency,
            formats: []
        };
        
        templateData.default_format.cost = el.calculator.cost;
        
        var price = el.calculator.price[el.calculator.priceGroupId][el.project.current.product_id];
        
        var propertyId, formatId, recordedFormats = {}, templateFormat;
        for (propertyId in price) {
            for (formatId in price[propertyId]) {
                if (!recordedFormats.hasOwnProperty(formatId)) {
                    recordedFormats[formatId] = true;
                    templateFormat = $.extend(true, {}, el.items[formatId]);
                    templateFormat.cost = el.calculator.getFormatCost(formatId);
                    templateData.formats.push(templateFormat);
                }
            }
        }
        
        templateData.formats.sort(function(a, b) {
            if (parseInt(a.height) < parseInt(b.height)) {
                return -1;
            }
            
            if (parseInt(a.height) === parseInt(b.height) && parseInt(a.width) < parseInt(b.width)) {
                return -1;
            }
            
            if (parseInt(a.height) === parseInt(b.height) && parseInt(a.width) === parseInt(b.width)) {
                return 0;
            }
            
            return 1;
        });

        var html = el.templater.render(template, templateData);
        $('.formats').html(html);
    };
    
    el.set = function(id) {
        el.current = el.items[id];
        el.upImages.reset();
        el.workarea.changeDimensions();
        el.workarea.render();
        el.calculator.init();
        el._parent.valve = parseInt(el.currentProduct.company.valve / el.MM_IN_PIXELS / el.workData.scale);
    };
    
    el.changeOrientation = function() {
        el.upImages.reset();
        el.workarea.rotateDimensions();
        el.workarea.render();
        el._parent.valve = parseInt(el.currentProduct.company.valve / el.MM_IN_PIXELS / el.workData.scale);
    };
    
    $(document).on('click', '.js-set-format', function() {
        el.set($(this).attr('data-id'));
    });
    
    $(document).on('click', '.js-change-orientation', function() {
        el.changeOrientation();
    });
};